<template>
  <div style="width: 100%;height: 100%">
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：{{ data[0].GYS_NAME }}</li>
          <li>联系电话：{{ data[0].GYS_TELPHONE }}</li>
          <li>地址：{{ data[0].PROJECT_ADDRESS }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}</li>
          <li>制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-button style="margin-bottom: 20px" type="primary" @click="downloadAllBatchReport">批量下载批次报告</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" :span-method="objectSpanMethod">
          <el-table-column type="index" label="序号" width="45" min-width="30" :index="indexMethod"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="验收总数量" width="150" min-width="60"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-show="fun_dic[100030301]">修改</el-button><br>
              <!-- 亦芙德专用 -->
              <el-button type="text" size="small" icon="el-icon-download" @click="downloadBatchReport(scope.row)"
                :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" prop="TC_NAME"></el-table-column>
          <el-table-column label="项目点-档口" prop="DK_NAME" width="100"></el-table-column>
          <el-table-column label="客户订购数量" prop="CUSTOMER_PRODUCT_COUNT"></el-table-column>
          <el-table-column label="供应商送货数量" prop="CUSTOMER_NEED_COUNT"></el-table-column>
          <el-table-column prop="PSZX_REAL_COUNT" label="验收数量" min-width="80"></el-table-column>
          <el-table-column label="客户备注" prop="CUSTOMER_PRODUCT_COMMENT"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;display: flex;">
      <el-col>
        <el-steps :active="statusFlag" finish-status="success" v-show="statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
      <el-col :span="2">
        <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="openPreviewDialog"
          v-if="USE_PRINT_TEMPLATE == 0">
          打印预览
        </el-button>
        <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary"
          v-if="USE_PRINT_TEMPLATE == 1" @click="previewPrint">
          打印预览
        </el-button>
      </el-col>
      <el-col :span="2">
        <el-button @click="confirmOrder" style="margin-top: 30px;float: right" type="primary" size="small"
          v-show="fun_dic[100030302]">
          确认订单
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
          <el-form :model="editForm" ref="editForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ name }}</span>
            </el-form-item>
            <el-form-item label="送货数量：" :label-width="formLabelWidth">
              <el-input v-model="editForm.NEED_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitEdit" :loading="loading">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-dialog title="是否打印价格" center :visible.sync="previewVisible" width="400px">
      <el-radio style="margin: 0px 80px 0 90px" v-model="carryPrice" label="1">是</el-radio>
      <el-radio v-model="carryPrice" label="0">否</el-radio>
      <el-form ref="nameForm" :model="form" :label-width="formLabelWidth" style="margin: 50px 0 0 0">
        <el-form-item label="公司名称：">
          <el-input v-model="nameForm.companyName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="preview" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  downloadOrderBatchReportFun,
  updateNewDetailFun,
  // supplierCusHisDetailFun,
} from 'api/sellOrder';
import { getActionFun } from 'api/login';
import {
  downloadBatchReport,
  supplierCondirmOrderFun,
} from '@/assets/api/shopOrderManage';
import bus from '@/assets/common/bus';
import util from '../../assets/common/util';
import http from '../../assets/common/http';

export default {
  data () {
    return {
      fromName: ['sellOrderSupplierPrintDetail', 'supplierCusOrderPrint', 'OrderConfirmList'],
      toName: ['sellOrderSupplierPrintDetail', 'supplierCusOrderPrint'],
      loading: false,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      name: '',
      USE_PRINT_TEMPLATE: 0,
      data: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      printStatus: '',
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
      companyID: Number(sessionStorage.getItem('tcId')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      checkData: [],
      statusFlag: 0,
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      addPoint: 0,
      PAGE_ID: '1000303', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100030301: 0, 100030302: 0 },
      currentOrderFlag: Number(sessionStorage.getItem('currentOrderFlag')),
      previewVisible: false,
      carryPrice: '0',
      nameForm: {
        companyName: '',
      },
      rids: [],
      rcounts: [],
      purchaseDetailIDList: [],
      tcNameList: [],
      tcNameRids: [],
      tcNameRcounts: [],
      form: {},
    };
  },
  methods: {
    // 是否使用模板
    queryForm () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 1,
        GYS_ID: sessionStorage.getItem('TEM_GYSSCID'),
      };
      http.post(params).then((result) => {
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------查看订单详情
    queryOrderDetailListData () {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 44,
        ORDER_ID: Number(this.ORDER_ID),
      };
      http.post(params)
        .then((result) => {
          this.tableData = result.length > 0 ? result[0].DETAIL : [];
          this.data = result.length > 0 ? result[0].TITLE : [];
          // ---------------------------------------获取判断的companyID
          this.companyID = result[0].TITLE[0].TC_ID;
          this.addPoint = result[0].TITLE[0].ADD_POINT;
          this.checkData = result[0].OR[0].DATA;
          this.statusFlag = result[0].OR[0].RN;
          this.purchaseDetailIDList = result[0].DETAIL.map((item) => item.PURCHASE_DETAIL_ID);
          this.tcNameList = result[0].DETAIL.map((item) => JSON.stringify({ PURCHASE_DETAIL_ID: item.PURCHASE_DETAIL_ID, TC_NAME: item.TC_NAME }));
          this.isRepeated();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openPreviewDialog () {
      this.nameForm.companyName = sessionStorage.getItem('company');
      this.previewVisible = true;
    },
    closeAll () {
      this.previewVisible = false;
    },
    // 供应商客户打印
    preview () {
      this.$router.push({ name: 'supplierCusOrderPrint' });
      sessionStorage.setItem('carryPrice', this.carryPrice);
      sessionStorage.setItem('supplierName', this.nameForm.companyName);
    },
    // 供应商客户打印
    previewPrint () {
      this.$router.push({ name: 'sellOrderSupplierPrintDetail' });
      sessionStorage.setItem('carryPrice', this.carryPrice);
      sessionStorage.setItem('supplierName', this.nameForm.companyName);
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 修改按钮
    openEdit (row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.PURCHASE_DETAIL_ID;
    },
    // 确认修改
    submitEdit () {
      const reg = /\d/;
      if (!reg.test(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'error' });
        return false;
      }
      if (!util.JudgmentUnit(this.editForm.TYPE_UNIT)) {
        // 如果不是
        const beInter = this.editForm.NEED_COUNT % 1 === 0;
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
          return false;
        }
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
        IS_SUPPLIER_CLIENT: 1,
      };
      this.loading = true;
      updateNewDetailFun(params)
        .then((result) => {
          this.loading = false;
          this.$message.show({ text: '操作成功', type: 'success' });
          this.editFormVisible = false;
          this.queryOrderDetailListData();
        })
        .catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    close () {
      this.editFormVisible = false;
      this.queryOrderDetailListData();
    },
    objectSpanMethod ({
      row, column, rowIndex, columnIndex,
    }) {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        if (columnIndex != 11 && columnIndex != 12 && columnIndex != 13 && columnIndex != 14 && columnIndex != 15) {
          if (columnIndex == 10) {
            if (this.tcNameRids.includes(rowIndex)) {
              return {
                rowspan: this.tcNameRcounts[this.tcNameRids.indexOf(rowIndex)],
                colspan: 1,
              };
            }
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
          if (this.rids.includes(rowIndex)) {
            return {
              rowspan: this.rcounts[this.rids.indexOf(rowIndex)],
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    isRepeated () {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        tmpSet.forEach((item1) => {
          let i = 0;
          this.purchaseDetailIDList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.rids.push(this.purchaseDetailIDList.indexOf(item1));
          this.rcounts.push(i);
        });
      }
      const tmpSet2 = new Set(this.tcNameList);
      if (tmpSet2.size != this.tcNameList.length) {
        tmpSet2.forEach((item1) => {
          let i = 0;
          this.tcNameList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.tcNameRids.push(this.tcNameList.indexOf(item1));
          this.tcNameRcounts.push(i);
        });
      }
    },
    indexMethod (index) {
      return [...new Set(this.purchaseDetailIDList)].indexOf(this.tableData[index].PURCHASE_DETAIL_ID) + 1;
    },
    // 确认订单
    confirmOrder () {
      const params = {
        ORDER_ID: Number(this.ORDER_ID),
      };
      supplierCondirmOrderFun(params)
        .then((result) => {
          this.$message.show({ text: '确认成功', type: 'success' });
          this.$router.push({ name: 'OrderConfirmList' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 下载批次报告
    downloadBatchReport (row) {
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((res) => {
        if (res[0]) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        }
      });
    },
    downloadAllBatchReport () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      downloadOrderBatchReportFun(params).then((res) => {
        if (res.length) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        } else {
          this.$message.show({ text: '订单内所有商品未上传批次报告', type: 'warning' });
        }
      });
    },
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryOrderDetailListData();
        that.queryBeforeFun();
        that.queryForm();
      }
    });
  },
  destroyed () {
    bus.$emit('submit', this.tableData);
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/supplierCusConfirmOrderDetail.vue